import { marqueeItems } from '@/mocks/site';

export default function MarqueeBar() {
  const list = [...marqueeItems, ...marqueeItems];
  return (
    <div className="w-full overflow-hidden border-y border-background-200 bg-accent-100">
      <div className="flex items-center gap-4 py-3">
        <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1 text-xs font-bold text-background-50 dark:text-foreground-950">
          <i className="ri-megaphone-line" aria-hidden="true"></i>
          今日热搜
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="gq-marquee flex w-max items-center gap-8">
            {list.map((item, idx) => (
              <span
                key={`${item}-${idx}`}
                className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-800"
              >
                <i className="ri-vip-crown-2-line text-accent-600" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}